<template>
  <!-- Komponent layoutu z dynamicznym sprawdzaniem uprawnień -->
  <component v-if="hasAccess($route.access)" :is="$route.meta.layout || 'div'">
    <router-view />
  </component>

  <!-- Przycisk powrotu do góry strony -->
  <button
    @click="backToTop"
    :class="{ 'd-none': showTopButton }"
    type="button"
    class="btn btn-floating btn-lg"
    id="btn-back-to-top"
  >
    <i class="icon icon-arrow-up"></i>
  </button>

  <!-- Globalny modal do obsługi np. ticketów -->
  <Ticket
    :title="modalState.title"
    :isVisible="modalState.isVisible"
    @close="hideModal"
  >
    <component :is="modalState.content" />
  </Ticket>
</template>

<script setup>
import { useAuthStore } from "@/stores/auth.store";
import router from "@/router";
import { useUserStore } from "@/stores/user.store";
import Ticket from "@/components/TicketModal.vue";
import { reactive } from "vue";

// Inicjalizacja store z danymi o sesji/uwierzytelnieniu
const authStore = useAuthStore();

// Jeśli nie ma tokena (czyli użytkownik nie jest zalogowany) – przekierowanie na stronę główną
if (!authStore.token) {
  router.push("/");
}

// Funkcja sprawdzająca, czy użytkownik ma dostęp do danego zasobu/widoku
function hasAccess(id) {
  const userStore = useUserStore();
  // Jeżeli access nie jest wymagany albo użytkownik ma odpowiednie uprawnienia – true
  return id === undefined || userStore.hasAccess(id);
}

// Zarządzanie stanem globalnego modala (np. do ticketów)
const modalState = reactive({
  isVisible: false,
  title: "",
  content: null, // Dynamiczny komponent jako treść modala
});

// Funkcja wyświetlająca modal (możesz wywołać z dowolnego miejsca przez window.$modal.showModal)
function showModal(title, component) {
  modalState.title = title;
  modalState.content = component;
  modalState.isVisible = true;
}

// Funkcja zamykająca modal
function hideModal() {
  modalState.isVisible = false;
  modalState.content = null;
}

// Udostępnienie globalnej obsługi modala przez window.$modal
window.$modal = { showModal, hideModal };
</script>

<script>
// Klasyczny script - tu obsługiwany jest przycisk przewijania do góry strony
export default {
  name: "CarViver",
  mounted() {
    // Gdy komponent zamontowany – ustawiamy nasłuchiwanie przewijania strony
    const that = this;
    window.onscroll = function () {
      that.scrollFunction();
    };
  },
  data() {
    return {
      showTopButton: true,    // Kontroluje widoczność przycisku "do góry"
      triggerPoint: 300,      // Po ilu pikselach scrolowania pojawia się przycisk
    };
  },
  methods: {
    // Funkcja wywoływana przy przewijaniu strony, ustala widoczność przycisku
    scrollFunction() {
      if (
        document.body.scrollTop > this.triggerPoint ||
        document.documentElement.scrollTop > this.triggerPoint
      ) {
        this.showTopButton = false;
      } else {
        this.showTopButton = true;
      }
    },
    // Przewijanie do góry strony
    backToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style>
h1 {
  font-size: 21px;
}

h2 {
  font-size: 21px;
}

h3 {
  font-size: 19px;
}

h5 {
  font-size: 16px;
}

p {
  font-size: 12px;
}

input {
  border: 1px solid #dedede;
}

input:active,
input:focus,
input:focus-visible {
  background-color: #f5f4f2;
  border: 1px solid #dedede;
  outline-width: 0;
}

body {
  margin: 0;
  background: #e8e8e8 url("./assets/bg.jpg") repeat-y center top;
}

#app {
  font-family: Ubuntu, "times new roman", times, roman, serif;
  font-style: normal;
  color: black;
  width: 1300px;
  margin: 0 auto;
}

table {
  margin-bottom: 0;
}

table thead,
table tbody {
  border-right: 1px solid #e1e1df;
}

.content-container {
  display: flex;
}

.content-container > div,
.content-container .content-wrap > .container {
  min-height: 400px;
}

.content-container .content-wrap {
  width: 100%;
}

.form-select {
  border-radius: 0;
  border-right: 1px solid #e1e1df;
}

.break {
  flex-basis: 100%;
  height: 0;
}

.sign {
  color: #eaeaea;
  font-weight: 1000;
  font-size: 15px;
}

.loading span {
  height: 30px;
  width: 30px;
  color: #dedede;
  border-width: 5px;
}

.alert {
  color: #ac304c;
}

.btn {
  border-radius: 0;
  padding: 2px 10px;
  font-size: 12px;
}
</style>
